import React from "react";
import Hero from "../components/Hero";
import PrayerTimes from "../components/PrayerTimes";
import NoticeBoard from "../components/NoticeBoard";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <>
      <Hero />
      <PrayerTimes />
      <NoticeBoard />
      <Footer />
    </>
  );
}
